import React from "react";

import { copyToClipboard, useGetPartners } from "utils";

import { AdminHead, AdminTable, Button, Card, Col, MainPage, Row, Typography, Message as message } from "components";

export const PartnerList = () => {
  const partnersQuery = useGetPartners();
  const partners = partnersQuery.data?.partners ?? [];
  const summary = partnersQuery.data?.summary ?? {
    purchasedCredits: 0,
    purchaseObligations: 0,
    pendingCredits: 0,
    receivedCredits: 0,
    partners: 0,
  };

  const copyLink = async (record) => {
    const success = await copyToClipboard(`${process.env.REACT_APP_FARM_URL}/sign-up?partner=${record.referralToken}`);
    if (success) {
      message({
        content: "The gremlins successfully vomited the referral code into your clipboard.",
        icon: "gremlin",
      });
    } else {
      message({
        content: "The gremlins were confused and had an unexpected problem. Try again.",
        icon: "gremlin",
      });
    }
  };

  const copyDairyLink = (record) => {
    copyToClipboard(`${process.env.REACT_APP_FARM_URL}/sign-up/dairy?partner=${record.referralToken}`);
    message({
      content: "The gremlins successfully vomited the referral code into your clipboard.",
      icon: "gremlin",
    });
  };

  const copyMeatLink = async (record) => {
    const success = await copyToClipboard(`${process.env.REACT_APP_FARM_URL}/sign-up/meat?partner=${record.referralToken}`);
    if (success) {
      message({
        content: "The gremlins successfully vomited the referral code into your clipboard.",
        icon: "gremlin",
      });
    } else {
      message({
        content: "The gremlins were confused and had an unexpected problem. Try again.",
        icon: "gremlin",
      });
    }
  };

  return (
    <MainPage loading={partnersQuery.isLoading} pageName={"admin"}>
      <AdminHead
        headline={`${partners.length} partners`}
        description="View, update or add partners here."
        extra={
          <Button size="small" type="secondary" href="/partners/add">
            Add
          </Button>
        }
      />
      <Row style={{ textAlign: "center" }}>
        <Col sm={24} md={6}>
          <Card className="content-card">
            <div style={{ margin: "0 auto" }}>
              <Typography variant="h3">{summary.purchasedCredits?.toFixed(3)}</Typography>
              <Typography variant="paragraph-m">Total purchased credits</Typography>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={6}>
          <Card className="content-card">
            <div style={{ margin: "0 auto" }}>
              <Typography variant="h3">{summary.purchaseObligations?.toFixed(3)}</Typography>
              <Typography variant="paragraph-m">Total purchase obligations</Typography>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={6}>
          <Card className="content-card">
            <div style={{ margin: "0 auto" }}>
              <Typography variant="h3">{summary.pendingCredits?.toFixed(3)}</Typography>
              <Typography variant="paragraph-m">Total pending credits</Typography>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={6}>
          <Card className="content-card">
            <div style={{ margin: "0 auto" }}>
              <Typography variant="h3">{summary.receivedCredits?.toFixed(3)}</Typography>
              <Typography variant="paragraph-m">Total received credits</Typography>
            </div>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <AdminTable
            dataSource={partners}
            config={{
              exclude: [
                "remainingCredits",
                "referralToken",
                "pointPriceCategory1",
                "pointPriceCategory2",
                "pointPriceCategory3",
                "pointPriceCategory4",
                "maxHectares",
                "contactPhone",
                "contactName",
                "contactEmail",
              ],
              actions: [
                {
                  icon: "tabler/arrow-right",
                  route: "/partners/update/",
                  tooltip: "Edit this partner",
                },
                {
                  icon: "tabler/copy",
                  func: copyLink,
                  tooltip: "Copy this CROPS referral link",
                },
                {
                  icon: "klim/cow",
                  func: copyDairyLink,
                  tooltip: "Copy this DAIRY referral link",
                },
                {
                  icon: "tabler/meat",
                  func: copyMeatLink,
                  tooltip: "Copy this MEAT referral link",
                },
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
